import { state } from '@/store/modules/customForm/state';
import { getters } from '@/store/modules/customForm/getters';
import { mutations } from '@/store/modules/customForm/mutations';
import { actions } from '@/store/modules/customForm/actions';

export const customForm = {
  state,
  getters,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/customForm/index.js